import { env } from '@/env'
import { useDevSettings } from '@/hooks/useDevSettings'
import { authClient } from '@/lib/auth-client'

/**
 * Where reminder emails go outside production. Scheduled reminders are automated sends,
 * so they fail closed: without a workspace override or sandbox (or the server's
 * EMAIL_DIVERT_TO) they are not sent at all. Send now follows the manual precedence and
 * falls back to the signed-in user's inbox.
 */
export function useReminderDivertNotice(): string | null {
  const isProd = env.VITE_DEPLOY_ENV === 'prod'
  const { data: session } = authClient.useSession()
  const { data: settingsResult } = useDevSettings({ enabled: !isProd })

  if (isProd) return null

  const settings = settingsResult?.data
  if (settings?.emailSandboxEnabled) {
    return "Dev / UAT: reminder emails go to the Resend sandbox and won't be delivered. View them in the Resend dashboard."
  }

  if (settings?.emailDivertOverrideEnabled && settings.emailDivertOverrideTo) {
    return `Dev / UAT: reminder emails are delivered to ${settings.emailDivertOverrideTo} (your test override), never to clients.`
  }

  const userEmail = session?.user?.email
  const sendNowTarget = userEmail ? `your own inbox (${userEmail})` : 'your own inbox'
  return `Dev / UAT: reminder emails never reach clients. Scheduled reminders are skipped unless a test inbox is set in Dev mode; Send now goes to ${sendNowTarget}.`
}
